import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

// Common Fragments
import { CompensationFragment, ReviewFragment } from "../../common/fragments";
import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";

export const approveAllAdvisorsWashout = async (...params: string[]) => {
	const [userId, locationId, commissionCycleId, payPeriodId, position] = params;
	const query = gql`
		mutation approveAllAdvisorsWashout(
			$userId: String!
			$locationId: String!
			$commissionCycleId: String!
			$payPeriodId: String!
			$position: String
		) {
			approveAllAdvisorsWashout(
				userId: $userId
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				position: $position
			) {
				success
			}
		}
	`;
	const variables = {
		userId,
		locationId,
		commissionCycleId,
		payPeriodId,
		position,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data.data?.approveAllAdvisorsWashout;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
};

export async function updateAdvisorsWashout(...params: string[]) {
	const [locationId, dataInput, position] = params;
	const query = gql`
		mutation updateAdvisorsWashout($locationId: String!, $input: WashoutInput!, $position: String) {
			updateAdvisorsWashout(locationId: $locationId, input: $input, position: $position) {
				_id
				commissionCycleId
				payPeriodId
				userId
				summary {
					...Compensation
				}
			}
		}
		${CompensationFragment}
	`;

	const variables = {
		input: dataInput,
		locationId,
		position,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateAdvisorsWashout;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
}

export async function updateAdvisorsWashoutStatus(...params: string[]) {
	const [locationId, commissionCycleId, payPeriodId, userId, input, position] = params;
	const query = gql`
		mutation updateAdvisorsWashoutStatus(
			$locationId: String!
			$commissionCycleId: String!
			$payPeriodId: String!
			$userId: String!
			$reviewInput: WashoutReviewInput
			$position: String
		) {
			updateAdvisorsWashoutStatus(
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				locationId: $locationId
				reviewInput: $reviewInput
				userId: $userId
				position: $position
			) {
				_id
				commissionCycleId
				payPeriodId
				userId
				position
				status
				review {
					...Review
				}
				employee {
					position
				}
			}
		}
		${ReviewFragment}
	`;

	const variables = { locationId, commissionCycleId, payPeriodId, userId, position, reviewInput: input };

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.updateAdvisorsWashoutStatus;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
}

export async function generateAdvisorsWashout(locationId: string, commissionCycleId: string, payPeriodId: string, userIds: string[]) {
	const query = gql`
		mutation generateWashouts($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!, $userIds: [String!]!) {
			generateWashouts(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userIds: $userIds) {
				success
			}
		}
	`;
	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		userIds,
	};
	try {
		const response: GraphqlQueryResponse<"generateWashouts", { success: boolean }> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.generateWashouts;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
}
